<div class="user-timeline">
  <!-- Loading State -->
  <div v-if="loading" class="text-center p-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p>Loading user timeline...</p>
  </div>

  <!-- Error State -->
  <div v-else-if="error" class="alert alert-danger">
    {{ error }}
  </div>

  <!-- User Logs -->
  <div v-else class="user-timeline-container">
    <div class="user-timeline-line"></div>
    
    <div v-for="(log, index) in user_activity_logs" :key="index" class="user-timeline-item mb-5">
      <!-- Status Icon -->
      <div :class="['user-timeline-icon', log.type === 'success' ? 'success' : 'error']">
        <i v-if="log.type === 'success'" class="fa fa-check-circle"></i>
        <i v-else class="fa fa-times-circle"></i>
      </div>

      <!-- Log Details -->
      <div class="user-timeline-content w-200 m-0">
        <p class="log-description w-150">
          <strong>Status:</strong> {{ log.status }} - {{ log.message }}
        </p>
        <p class="log-date w-150">
          {{ log.date }} - {{ log.time }}
        </p>
      </div>
    </div>

    <!-- No Activity Found -->
    <div v-if="user_activity_logs.length === 0" class="text-center p-4">
      No user activity found.
    </div>
  </div>
</div>